import { render, staticRenderFns } from "./beyondBackRperotList.vue?vue&type=template&id=8451178c"
import script from "./beyondBackRperotList.vue?vue&type=script&lang=js"
export * from "./beyondBackRperotList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports